export default __webpack_public_path__ + "static/media/refresh.1c498b72.svg";